export const attendeeTablePurchaserStyle = {
	tableContent: {
		display: 'flex',
		flexDirection: 'column',
		justifyContent: 'space-between',
		height: 'calc(100% - 46px)',
		marginBottom: '24px',

		'& .MuiTableBody-root': {
			backgroundColor: 'var(--neutral-50)',

			'& .MuiTableRow-root': {
				outline: '1px solid var(--neutral-100)',
				outlineOffset: '-1px',
				borderBottomLeftRadius: 'var(--default--border-radius)',
				borderBottomRightRadius: 'var(--default--border-radius)',
			},
		},

		'@media (max-width: 767.98px)': {
			display: 'none',
		},
	},

	container: {
		overflowX: 'unset',
	},

	table: {
		maxWidth: '1119px',
		tableLayout: 'fixed',
		borderCollapse: 'inherit',

		'& .MuiTableHead-root': {
			position: 'relative',
			top: '5px',
		},

		'& .MuiTableBody-root': {
			minHeight: '70px',
			height: '100%',
		},
	},

	tableHeader: {
		'& > :nth-of-type(1)': {
			textTransform: 'capitalize',
			width: '10%',

			'@media (min-width: 1200px)': {
				display: 'none',
			},
		},
		'& > :nth-of-type(2)': {
			width: '10%',

			'@media (min-width: 1200px)': {
				display: 'none',
			},
		},

		'& > :nth-of-type(3)': {
			width: '26%',

			'@media (max-width: 1199.98px)': {
				width: '20%',
			},
		},
		'& > :nth-of-type(4)': {
			width: '27%',

			'@media (max-width: 1199.98px)': {
				width: '20%',
			},
		},
		'& > :nth-of-type(5)': {
			width: '12%',

			'@media (max-width: 1199.98px)': {
				width: '16%',
			},
		},
		'& > :nth-of-type(6)': {
			width: '11%',
		},
		'& > :nth-of-type(7)': {
			width: '12%',
			textTransform: 'capitalize',
		},
		'& > :nth-of-type(8)': {
			width: '12%',

			'@media (max-width: 1199.98px)': {
				display: 'none',
			},
		},
	},

	tableBody: {
		'& > :nth-of-type(1)': {
			'&.MuiTableCell-body .MuiTypography-root': {
				'&.MuiTypography-subtitle2': {
					fontWeight: 700,
					color: 'var(--primary-500)',
				},
			},
			'@media (min-width: 1200px)': {
				display: 'none',
			},
		},
		'& > :nth-of-type(2)': {
			'&.MuiTableCell-body .MuiTypography-root': {
				'&.MuiTypography-subtitle2': {
					fontWeight: 700,
					color: 'var(--primary-500)',
				},
			},
			'@media (min-width: 1200px)': {
				display: 'none',
			},
		},

		'& > :nth-of-type(3)': {
			'&.MuiTableCell-body .MuiTypography-root': {
				'&.MuiTypography-subtitle2': {
					fontWeight: 700,
					'&:hover': {
						cursor: 'pointer',
						textDecoration: 'underline',
					},
				},
				'&.MuiTypography-body2': {
					color: 'var(--neutral-300)',
				},
			},
		},

		'& > :nth-of-type(4)': {
			'& .MuiBox-root': {
				display: 'flex',
			},

			'&.MuiTableCell-body .MuiTypography-root': {
				'&.MuiTypography-subtitle2': {
					fontWeight: 700,
					paddingRight: '4px',
				},
				'&.MuiTypography-body2': {
					color: 'var(--neutral-300)',
					whiteSpace: 'normal',
					overflow: 'visible',
					wordBreak: 'break-word',
				},
			},
		},

		'& > :nth-of-type(8)': {
			width: '10%',

			'@media (max-width: 1199.98px)': {
				display: 'none',
			},
		},

		'& .MuiTableCell-root': {
			textOverflow: 'ellipsis',
			overflow: 'hidden',
			paddingTop: '8px !important',
			paddingBottom: '8px !important',
		},
	},

	pendingStatus: {
		svg: {
			'& circle': {
				fill: 'var(--neutral-400) !important',
			},
		},
	},
};
